import React from 'react';
import { Grid } from 'semantic-ui-react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteRental } from '../../redux/actions/userActions';
import { populateRental, addFavRental } from '../../redux/actions/rentalActions';
import { openModal, closeModal } from '../../redux/actions/modalActions';
import { addItemToCart, toggleCartDropDown } from '../../redux/actions/cartActions';
import { toastr } from 'react-redux-toastr';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import { useDocument } from '../../hooks/useDocument';
import { db } from '../../firebase';

//components
import Loader from '../../components/loader/SimpleLoader';
import GoogleMap from '../../components/google-map/GoogleMap';
import Sidebar from './Sidebar';
import ItemSegment from './ItemSegment';

const ItemPage = ({ match, history }) => {

  const rentalId = match.params.rentalId;
  const dispatch = useDispatch();
  const [rentalItem, loading] = useDocument(db.doc(`rentals/${rentalId}`));
  const uid = useSelector((state) => state.auth.currentUser?.uid);
  const isRentalInWishlist = useSelector(state => state.rentals.favRentals?.some(rental => {
      return rental.id === rentalId
  })); 

  const isOwner = rentalItem?.ownerUid === uid;

  const handleRedirectToForm = () => {
    dispatch(populateRental(rentalItem));
    history.push(`/store/manage/${rentalId}`);
  };

  const handleConfirm = async () => {
    dispatch(closeModal());
    const { success } = await dispatch(deleteRental(rentalId));
    if (success) history.push('/store');
  };

  const handleCancel = () => {
    dispatch(closeModal());
  };

  const handleOpenModal = () => {
    dispatch(
      openModal('ConfirmModal', {
        content: 'Are you sure ?',
        handleConfirm,
        handleCancel,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Yes',
        size: 'tiny',
        style: { padding: '10px' },
      })
    );
  };

  const handleAddItem = () => {
    if (
      rentalItem.status === 'rented' ||
      rentalItem.status === 'inactive' ||
      rentalItem.status === 'pending'
    ) {
      return toastr.info(
        'Info',
        'This item is rented or unavailable for rent.'
      );
    }
    dispatch(addItemToCart(rentalItem));
    dispatch(toggleCartDropDown());
  };

  const handleWishlistItem = () => {
    const rental= Object.assign(
      {},
      {
        id: rentalItem?.id,
        image: rentalItem?.image,
        name: rentalItem?.name,
        description: rentalItem?.description,
        half_day_price: rentalItem?.half_day_price,
        full_day_price: rentalItem?.full_day_price
      }
    );
   dispatch(addFavRental(rental));
  };

  const handleContactOwner = () => {
     history.push(`/user_profile/${rentalItem?.ownerUid}`);
  };

  if (loading) return <Loader />;
  if (!rentalItem?.name) return <Redirect to='/not-found' />;

  return (
    <Grid stackable reversed='mobile'>
      <Helmet>
        <title> {rentalItem?.name} </title>
        <meta name='description' content={rentalItem?.description} />
      </Helmet>
      <Grid.Column width={10}>
        <ItemSegment
          size='small'
          rentalItem={rentalItem}
          handleRedirectToForm={handleRedirectToForm}
          handleWishlistItem={handleWishlistItem}
          handleAddItem={handleAddItem}
          openModal={handleOpenModal}
          handleContactOwner={handleContactOwner}
          isOwner={isOwner}
          isRentalInWishlist={isRentalInWishlist}
        />
        <GoogleMap geoLocation={rentalItem?.g?.geopoint} />
      </Grid.Column>
      <Grid.Column width={6}>
        <Sidebar rentalItem={rentalItem} />
      </Grid.Column>
    </Grid>
  );
};

export default ItemPage;
